<template>
  <div class="popUpWrap">
    <section class="popup dark assessment">
      <div class="topArea">
        <div class="exit" @click.stop="onClickClose"></div>
      </div>
      <div class="scrollY">
        <div class="icon fail"></div>
        <h5>{{ t('skillCertify-caution') }}</h5>
        <p v-html="convertToNextLine(t('skillCertify-caution-tab-switch'))" />
        <div class="btnArea">
          <button @click.stop="onClickClose">{{ t('common-continue') }}</button>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import {useDialogStore} from '~/store/dialog/dialogStore';
import {useI18n} from 'vue-i18n';
import DialogType from '~~/application/components/Common/Dialog/model/DialogType';
import { convertToNextLine } from "~~/application/utils/StringUtil";

const { t } = useI18n();
const dialogStore = useDialogStore();

const onClickClose = () => {
  dialogStore.deleteMultiOption({
    type: DialogType.CautionTabChangePopup
  })
};

</script>

